<template>
  <div class="text-expander-fi">
    <div
      :class="{
        'text-expander-fi__content': true,
        'text-expander-fi__content--expanded': isExpanded || !isExpandable,
        'text-expander-fi__content--expandable': isExpandable,
      }"
      :style="{
        gridTemplateRows: `${maxHeight}px ${isExpanded ? 1 : 0}fr`,
        maxHeight: isExpandable ? undefined : `${maxHeight}px`,
      }"
    >
      <div class="text-expander-fi__inner">
        <richtext-fi
          ref="expanderContent"
          :html-content="content"
        />
      </div>
    </div>

    <div
      v-if="isExpandable"
      class="text-expander-fi__expand"
    >
      <span
        class="text-expander-fi__expand-text"
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? reduceText : expandText }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RichtextFi } from 'atoms';
import { onMounted, ref, useTemplateRef } from 'vue';

import type { SingleLineTextField } from '@/sitecoreFieldTypes';

interface Props {
  content?: SingleLineTextField;
  expandText?: string;
  reduceText?: string;
  maxHeight?: number;
}

const props = withDefaults(defineProps<Props>(), {
  content: () => ({}),
  expandText: 'expand',
  reduceText: 'reduce',
  maxHeight: 200,
});

const isExpandable = ref(false);
const isExpanded = ref(false);

const expanderContent = useTemplateRef<InstanceType<typeof RichtextFi>>('expanderContent');

onMounted(() => {
  if (IS_SSR) {
    return;
  }

  if (expanderContent.value?.$el?.clientHeight > props.maxHeight) {
    isExpandable.value = true;
  }
});
</script>

<style scoped src="./text-expander-fi" />
